export const TABLE_PARAM_KEY = (tableId: string) => `tbl:${tableId}`;
export const TABLE_META_KEY = (tableId: string) => `tblmeta:${tableId}`;
export const TABLE_SESSION_PARAM_KEY = (tableId: string) => `tblsession:${tableId}`;
export const TABLE_COLUMNS_KEY = (tableId: string) => `tblcols:${tableId}`;
